/**
 * Copyright (C) 2019 Egylis,
 * Siège social, 83 bis rue de l'Abbé Groult, 75015 Paris - France.
 * All Rights Reserved.
 *
 * E-mail : info@egylis.com
 *
 * This software is the confidential and proprietary information
 * of Egylis. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only
 * in accordance with the terms of the license agreement you
 * entered into with Egylis.
 *
 * Created by calvez on 18/03/2019.
 *
 * Version : Generator 2.0.9
 */

import {TranslateLoader} from '@ngx-translate/core';
import {Observable, from} from 'rxjs';

/**
 * WebPack Translate Loader.
 * https://github.com/ngx-translate/http-loader/issues/25
 */
export class WebpackTranslateLoader implements TranslateLoader {
    getTranslation(lang: string): Observable<any> {
        return from(import(`../../assets/i18n/${lang}.json`));
    }
}
